/*eslint-disable*/ export const messages = {
    "Go to the first page": "最初のページに移動",
    "Go to the last page": "最後のページに移動",
    "Pagination, showing {from} through {to} of {total} entities": [
        "ページネーション、",
        ["total"],
        " 件のうち ",
        ["from"],
        " から ",
        ["to"],
        " 件目を表示中です",
    ],
    "Show next {entitiesPerPage} entities": ["次の ", ["entitiesPerPage"], " 件を表示"],
    "Show previous {entitiesPerPage} entities": ["前の ", ["entitiesPerPage"], " 件を表示"],
    "{from} through {to} of {total}": [["total"], " 件のうち ", ["from"], " から ", ["to"], " 件目"],
    "{from}-{to} of {total}": [["total"], " 件のうち ", ["from"], " ～ ", ["to"], " 件目"],
};
